import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY || 'placeholder';

export const DEMO_READ_ONLY_MESSAGE = 'Modo demonstração: somente leitura. Fale com a gente para usar o sistema na sua loja.';

// Modo demo (ligado pelo AuthContext): toda gravação volta com erro antes de sair do navegador.
// Quem protege de verdade é o RLS do banco; isto só evita a tela "salvar" algo que o banco recusaria.
let demoReadOnly = false;
export const setDemoReadOnly = (on) => { demoReadOnly = !!on; };

// O próprio perfil (login, aceite dos termos) e o registro de navegação continuam liberados
const DEMO_ALLOWED_WRITES = ['/rest/v1/user_profiles', '/rest/v1/rpc/log_event', '/rest/v1/rpc/track_presence'];
const READ_METHODS = ['GET', 'HEAD', 'OPTIONS'];

const demoAwareFetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : input.url;
    const method = (init.method || (typeof input === 'string' ? 'GET' : input.method) || 'GET').toUpperCase();
    const path = new URL(url).pathname;
    const isDataWrite = (path.startsWith('/rest/v1/') || path.startsWith('/functions/v1/')) && !READ_METHODS.includes(method);
    if (demoReadOnly && isDataWrite && !DEMO_ALLOWED_WRITES.some((p) => path.startsWith(p))) {
        return Promise.resolve(new Response(
            JSON.stringify({ code: 'DEMO_READ_ONLY', message: DEMO_READ_ONLY_MESSAGE, error: DEMO_READ_ONLY_MESSAGE, success: false }),
            { status: 403, headers: { 'Content-Type': 'application/json' } }
        ));
    }
    return fetch(input, init);
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, { global: { fetch: demoAwareFetch } });
